/**
 * Utility functions for formatting and calculations
 */

/**
 * Format currency for display
 */
export function formatCurrency(value: number | undefined | null, includePence: boolean = false): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return 'TBC';
  }
  if (includePence) {
    return `£${value.toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }
  return `£${Math.round(value).toLocaleString('en-GB')}`;
}

/**
 * Format currency with safe fallbacks for incomplete data
 */
export function formatSafeCurrency(value: number | undefined | null): string {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return 'Pending data...';
  }
  return `£${Math.round(value).toLocaleString('en-GB')}`;
}

/**
 * Format delta with sign and direction
 */
export function formatDelta(delta: number): string {
  const sign = delta >= 0 ? '+' : '';
  return `${sign}${formatCurrency(delta)}`;
}

/**
 * Get trend indicator
 */
export function getTrend(delta: number): 'positive' | 'negative' | 'neutral' {
  if (delta > 0) return 'positive';
  if (delta < 0) return 'negative';
  return 'neutral';
}

/**
 * Get suitability color
 */
export function getSuitabilityColor(suitability: 'high' | 'medium' | 'low'): string {
  switch (suitability) {
    case 'high':
      return '#10b981'; // green
    case 'medium':
      return '#f59e0b'; // amber
    case 'low':
      return '#ef4444'; // red
  }
}
